<template>
	<div class="container" :class="isOpen ? '' : 'not-expanded'">
		<div class="faq-toggle header" @click="toggle">
			<h3>{{ header }}</h3>
			<font-awesome-icon icon="fa-light fa-chevron-down" size="1x" />
		</div>
		<div class="faq-content content">
			<Transition name="fade-in-up">
				<div v-if="isOpen" :key="animationKey" v-parse-links v-html="content" />
			</Transition>
		</div>
	</div>
</template>

<script setup>
const props = defineProps({
	header: { type: String, default: '' },
	content: { type: String, default: '' },
	isOpen: { type: Boolean, default: false },
});

const emit = defineEmits(['update:isOpen']);

const toggle = () => {
	emit('update:isOpen', !props.isOpen);
};
</script>

<style lang="scss" scoped>
.fade-in-up-enter-active {
	transition:
		opacity 0.6s ease-in-out,
		transform 0.6s ease-in-out;
}

.fade-in-up-leave-active {
	transition:
		opacity 0.6s ease-in-out,
		transform 0.6s ease-in-out;
}

.fade-in-up-enter-from,
.fade-in-up-leave-to {
	opacity: 0;
	transform: translateY(-20px);
}

.fade-in-up-enter-to,
.fade-in-up-leave-from {
	opacity: 1;
	transform: translateY(0);
}

.faq-row {
	max-width: 1180px;
	margin: 20px auto 40px;
}

.faq-content {
	padding: 5px 0;
}

.faq-toggle {
	transition: all 0.3s ease-in-out;
	background: none;
	cursor: pointer;
	font-weight: 700;
	padding: 20px 54px 20px 0;
	position: relative;
}

.faq-toggle svg {
	color: var(--body-color);
	font-size: 18px;
	font-weight: 400;
	margin-top: -9px;
	position: absolute;
	right: 0;
	top: 50%;
	transform: rotate(180deg);
	transition: all 0.3s ease-in-out;
}

.not-expanded .faq-toggle svg {
	transform: rotate(0deg);
}

.faq-toggle h3 {
	font-size: 20px;
	font-weight: 500;
	margin: 0;
	line-height: 1.45;
}

.header {
	cursor: pointer;
	transition: all 0.3s ease-in-out;
}

.container {
	display: inline-block;
	vertical-align: top;
	text-align: left;
	width: 100%;
	overflow: hidden;

	.content {
		transition: all 0.3s ease;
		transform-origin: top;

		ul,
		ol {
			padding: 0 0 0 20px;
		}
	}

	&.not-expanded .content {
		transform: scaleY(0);
		transform-origin: top;
		opacity: 0;
		height: 0;
		padding: 0 20px;
		transition: all 0.3s ease;
	}
}

@media (max-width: 500px) {
	.faq-toggle h3 {
		font-size: 20px;
		line-height: 1.25;
	}
}
</style>
